import dayjs from 'dayjs';

export const getHolidayTimeSpan = (dateFrom: string, dateTo: string, format: string): string => {
  const dateFromFormat = dayjs(dateFrom).format(format);
  const dateToFormat = dayjs(dateTo).format(format);

  return dateFromFormat === dateToFormat ? dateFromFormat : `${dateFromFormat} - ${dateToFormat}`;
};
